module.exports = __webpack_public_path__ + "media/images/lb/356-0e6a71575b93d1eb61762f13cb854fde.svg";